export const SURVEY_QUESTIONS = [
  {
    id: "q1_where_with_matcha",
    title: "Where are you with matcha right now?",
    options: [
      "It's already a daily ritual for me",
      "I'm a recent convert",
      "Curious, but still new to it",
      "Honestly, I'm more of a coffee person",
    ],
  },
  {
    id: "q2_when_visiting",
    title: "When can you picture coming in?",
    options: [
      "A morning ritual to start the day",
      "A midday or afternoon pause",
      "A quick matcha on the go",
      "A moment to sit with it before you head off",
    ],
  },
  {
    id: "q3_first_order",
    title: "What would you order first?",
    options: [
      "A hot matcha latte",
      "An iced matcha",
      "A coffee",
      "A matcha pastry (gluten-free, no refined sugar)",
    ],
  },
  {
    id: "q4_matcha_at_home",
    title: "Would you want Hontō matcha for home, too?",
    options: [
      "Yes — I'd make it daily",
      "Sometimes",
      "Maybe, if you showed me how",
      "I'll stick to in-store",
    ],
  },
];
